import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { validateVerificationToken } from '@/actions/authActions'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useReselector } from '@/utils/sharedHooks'

import { Heading, HeadingVariants, Input, Text } from '@/ui'
import { VerificationDialog } from './VerificationDialog'
import { ChangeEmailDialog } from './ChangeEmailDialog'
import { ChangePassword } from './ChangePassword'

export const Credentials = () => {
  const dispatch = useAppDispatch()
  const { token } = useParams()
  const currentUser = useReselector(getCurrentUser)
  const [successfullyVerified, setSuccessfullyVerified] = useState(true)

  useEffect(() => {
    const checkToken = async () => {
      if (token) {
        const res = await validateVerificationToken(token)(dispatch)
        setSuccessfullyVerified(res)
      }
    }

    checkToken()
  }, [dispatch, token])

  const isVerified = Boolean(currentUser?.verifiedAt)

  return (
    <div className="mb-6">
      {currentUser && (
        <>
          <Heading variant={HeadingVariants.H3}>Email</Heading>

          <div className="flex items-center gap-2 w-full md:w-2/3">
            <Input
              className="flex-1"
              placeholder={currentUser.email}
              value={currentUser.email}
              error={!currentUser.verifiedAt}
              readOnly
            />

            <div className="flex-shrink-0">
              <ChangeEmailDialog />
            </div>
          </div>

          {!isVerified && (
            <div className="flex gap-2 flex-row items-center">
              <Text className="text-danger">
                This email has not been verified
              </Text>

              <VerificationDialog isVerified={successfullyVerified} />
            </div>
          )}
        </>
      )}
      <br />

      <Heading variant={HeadingVariants.H3} className="mb-2">
        Password
      </Heading>

      <div className="flex items-center gap-2 w-full md:w-2/3 mb-3">
        <Input className="flex-1" value="********" readOnly />
        <ChangePassword />
      </div>
    </div>
  )
}
